import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from "rxjs/operators";
import { AngularFirestore, DocumentData, QueryFn } from '@angular/fire/firestore';
import { DataService } from '../data.service';
import { InventoryItemDTO } from 'src/app/models/results/inventory-item-dto';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/non-vendor/environment';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { VivacityInventoryItem } from 'src/app/models/data/vivacity/vivacity-inventory-item';
import { constants } from 'src/environments/constants';
import { ILocaleInfo, UtilityService } from '../../utility.service';

@Injectable({
  providedIn: 'root'
})
export class VivacityDataService implements DataService {

  constructor(
    private store: AngularFirestore,
    private auth: AngularFireAuth,
    private utilityService: UtilityService) { }

  updateResultConfigItem(item: ResultConfigViewModel): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  getAdminEmailAddresses(): Observable<string[]> {
    return of([]);
  }

  executeDatabaseQuery(): Observable<InventoryItemDTO[]> {
    const localeInfo: ILocaleInfo = this.utilityService.getLocaleInfo();

    const queryFn: QueryFn<DocumentData> = ref => ref.where('Locality', '==', localeInfo.localeName).where('Deleted', '==', false);

    return this.auth.user.pipe(
      take(1),
      switchMap(async user => {
        if (!user) {
          await this.auth.signInWithEmailAndPassword(environment.firebaseUserEmail, environment.firebase.apiKey);
        }
      }),
      switchMap(() => this.store.collection<VivacityInventoryItem>(`${constants.FIRESTORE_INVENTORY_COLLECTION}_vivacity`, queryFn).valueChanges()),
      take(1),
      map((VivacityItems: VivacityInventoryItem[]) => {
        return VivacityItems.map(VivacityItem => this.mapDTO(VivacityItem));
      })
    );
  }

  mapDTO(VivacityItem: VivacityInventoryItem): InventoryItemDTO {
    return Object.assign(new InventoryItemDTO(), {
      id: VivacityItem.ID,
      hasBacklitKeyboard: VivacityItem.BacklitKeyboard,
      hasFingerprintReader: VivacityItem.HasFingerprintReader,
      hasPrivacyScreen: VivacityItem.HasPrivacyScreen,
      hasStylus: VivacityItem.HasStylus,
      cpuModel: VivacityItem.CpuModel,
      diskDriveSize: VivacityItem.DiskDriveSize,
      diskDriveUnit: VivacityItem.DiskDriveUnit,
      diskDriveType: VivacityItem.DiskDriveType,
      hasTouchscreen: VivacityItem.HasTouchscreen,
      imageLargeLocation: VivacityItem.ImageLarge,
      isChromeX: VivacityItem.IsChromeX,
      isEducation: VivacityItem.IsEducation,
      isParallelsCapable: VivacityItem.IsParallelsCapable,
      listPrice: VivacityInventoryItem.getPrice(VivacityItem),
      locality: VivacityItem.Locality,
      manufactureName: VivacityItem.ManufactureName,
      manufacturePart: VivacityItem.ManufacturePart,
      materialID: VivacityItem.MaterialID,
      memorySize: VivacityItem.MemorySize,
      memoryUnit: VivacityItem.MemoryUnit,
      name: VivacityItem.ProductDescShort.split(' - ')[0],
      productDescLong: VivacityItem.ProductDescLong,
      productDescShort: VivacityItem.ProductDescShort,
      productLine: VivacityItem.ProductLine,
      productType: VivacityItem.ProductType,
      formattedScreenSize: VivacityItem.ScreenSize,
      screenSize: VivacityInventoryItem.getScreenSize(VivacityItem),
      showInResults: VivacityItem.ShowInResults,
      vendorURL: VivacityItem.VendorURL
    });
  }
}
